



























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import numeral from 'numeral';
import GoodsDetailModal from './GoodsDetailModal.vue';
import ImportGoodsModal from './ImportGoodsModal.vue';

@Component({
    components: {
        GoodsDetailModal,
        ImportGoodsModal,
    }
})
export default class GoodsList extends Vue {
    @Prop({ required: true })
    private quotationId!: number | string;

    @Prop({ default: () => [] })
    private items!: any[];

    @Prop({ default: 0 })
    private totalGoods!: number;

    private isModalVisible: boolean = false;
    private selectedItem: any = {};
    private isImportModalVisible: boolean = false;

    private openModal(item: any) {
        this.selectedItem = item;
        this.isModalVisible = true;
    }

    private closeModal() {
        this.isModalVisible = false;
        this.selectedItem = {};
    }

    private openImportModal() {
        this.isImportModalVisible = true;
    }

    private closeImportModal() {
        this.isImportModalVisible = false;
    }

    private onImportSuccess() {
        this.$emit('refresh');
    }

    private formatCurrency(val: number): string {
        if (!val) return '0 đ';
        return numeral(val).format('0,0') + ' đ';
    }
}
